module.exports = __webpack_public_path__ + "img/TCA-box.6ba3acac.svg";